module.exports = __webpack_public_path__ + "4daecacbf81009028828c8b63cdebfb8.svg";